export default __webpack_public_path__ + "media/images/images/icons/textarea-expand-8f76d4d87af3d75aec81ed158e109c6b.png";